/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FilesIllustrationEditHomeIcon = createIcon("FilesIllustrationEditHomeIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0v80h80V0Z",
    fill: "#E1F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5.5H.5v79h79V.5Z",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 15H11a1 1 0 00-1 1v48a1 1 0 001 1h58a1 1 0 001-1V16a1 1 0 00-1-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 15.5h-57a1 1 0 00-1 1v47a1 1 0 001 1h57a1 1 0 001-1v-47a1 1 0 00-1-1Z",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 24H25v1h18v-1Zm19 0H52v1h10v-1Zm-19 8H25v1h18v-1Zm19 0H52v1h10v-1Zm-19 8H25v1h18v-1Zm19 0H52v1h10v-1Zm-19 8H25v1h18v-1Zm19 0H52v1h10v-1Zm-19 8H25v1h18v-1Zm19 0H52v1h10v-1ZM20 22h-5v5h5v-5Zm0 8h-5v5h5v-5Zm0 8h-5v5h5v-5Zm0 8h-5v5h5v-5Zm0 8h-5v5h5v-5Z",
    fill: "#C8C8C8"
  }));
}, {});